export enum PackageLocationType {
  Airport = "AIRPORT",
  City = "CITY",
  Hotel = "HOTEL",
  Region = "REGION",
}
